import React, { useReducer, useMemo, useState, useContext } from "react";
import { useHttpClient } from "../../shared/hooks/http-hook";
import { AuthContext } from "../../shared/context/auth-context";
import { useHistory } from "react-router-dom";
import AlterationItem from "../components/AlterationItem";
import { formReducer, INITIAL_STATE } from "../components/formReducer";
import { v4 as uuid } from "uuid";
import "./Alterations.css";
import Scroll from "../../shared/components/navigation/Scroll";
import moment from "moment";
import "tachyons";
import Capitalize from "../../shared/components/UIElements/Capitalize ";
import {formatDate} from "../components/formReducer"
import { services } from "../components/Services"
import { useWindow } from '../../shared/hooks/window-hook';

function NewAlterations() {
  const { sendRequest } = useHttpClient();
  const auth = useContext(AuthContext);
  const history = useHistory();
  const { width } = useWindow();

  const sortServices = services.sort((a, b) => {
    if (a.name === b.name) return 0;
    return a.name > b.name ? 1 : -1;
  });

  const orderNumber = useMemo(() => uuid().slice(0, 8), []);
  const [state, dispatch] = useReducer(formReducer, INITIAL_STATE);
  const [dateView, setDateView] = useState(formatDate())
  const [toggleValue, setToggleValue] = useState(false);


  const replaceSpecialCharacters = (str) => {
    return str.replace(/[^a-zA-Z ]/g, " ")
  }

  const handleChange = (e) => {
    if (e.target.id === "Due_Date") {
      setDateView(e.target.value)
    }
    if (e.target.id === "Tax") {
      setToggleValue(!toggleValue);
      dispatch({
        type: "CHANGE_INPUT",
        payload: { name: "Tax", value: e.target.value },
      });
    } else{
      dispatch({
        type: "CHANGE_INPUT",
        payload: { name: e.target.name, value: e.target.value },
      });
    }
  };



  const orders = Object.entries(state)
    .filter((any) => {
      return (
        any[0] !== "Customer_Name" &&
        any[0] !== "Customer_Phone" &&
        any[0] !== "Order_Number" &&
        any[0] !== "Due_Date" &&
        any[0] !== "Description" &&
        any[0] !== "Date" &&
        any[0] !== "Tax" &&
        any[0] !== "Custome_Service" &&
        any[1] !== "0" &&
        any[0] !== "archive"
      );
    })
    .map((any) => {
      return {
        price: any[1],
        quantity: "1",
        style: any[0].replaceAll("_", " ").toUpperCase(),
        company: any[0].replaceAll("_", " ").toLowerCase(),
        discount: "0",
      };
    });

  const printObj = {
    type: "alteration",
    customerName: Capitalize(state.Customer_Name),
    date: moment().format("YYYY-MM-DD"),
    orderNumber: state.Order_Number ? state.Order_Number : orderNumber,
    orders: orders,
    phone: state.Customer_Phone,
    salesTax: state.Tax === true ? "on": "off",
    description: replaceSpecialCharacters(Capitalize(state.Description)),
    dueDate: state.Due_Date,
    // archive: state.archive.value,
    archive: false,
  };

  const submitHandler = async () => {
    state.Custome_Service > 0 &&
      printObj.orders.push({
        price: state.Custome_Service,
        quantity: "1",
        style: "SPECIAL SERVICE",
        company: "",
        discount: "0",
      });

    try {
      await sendRequest(
        process.env.REACT_APP_BACKEND_URL + "/alterations/new",
        "POST",
        JSON.stringify(printObj),
        {
          "Content-Type": "application/json",
          Authorization: "Bearer " + auth.token,
        }
      );
      history.push(`/print/${JSON.stringify(printObj)}`, {
        from: "Alterations",
      });
    } catch (err) {}
  };

  return (
    <React.Fragment>

      <div className={width > 800 ? "flex" : ""}>
        
        <div className={width > 800 ? "w-50 pa3 mr2 ml5 mt6" : ""}>
          <div className="flex-row-ns flex justify-around">
            <div className="w-50 pa1 mr1">
              <label>Order Number</label>
              <input
                id = "Order_Number"
                className=" pa2 input-reset ba bg-transparent  hover-block "
                type="text"
                placeholder="Order #"
                name="Order_Number"
                onChange={handleChange}
                // style={{ width: "320px" }}
                defaultValue={orderNumber}
              />
            </div>
            <div className="w-50 pa1 mr1"> 
              <label>Due Date</label>
              <input
                id="Due_Date"
                autoFocus
                className="alteration_date_input input-reset ba bg-transparent  hover-black w-100"
                type="date"
                name="Due_Date"
                onChange={handleChange}
                // min={formatDate()}
                // style={{ width: "200px", height: "25px" }}
                value={dateView}
              />
            </div>
          </div>
          {/* <div className="flex-auto flex flex-column flex-row-ns justify-around"> */}
          <div className="flex-row-ns flex justify-around">
            <div className="alteration-input w-50 pa1 mr1">
              <label>Customer Name</label>
              <input
                id = "Customer_Name"
                className=" pa2 input-reset ba bg-transparent  hover-black "
                type="text"
                placeholder="Customer Name"
                name="Customer_Name"
                onChange={handleChange}
                // style={{ width: "320px" }}
              />
            </div>
            <div className="alteration-input w-50 pa1 mr1">
              <label>Phone Number</label>
              <input
                id="Customer_Phone"
                className=" pa2 input-reset ba bg-transparent  hover-black w-100"
                type="text"
                placeholder="##########"
                name="Customer_Phone"
                onChange={handleChange}
                // style={{ width: "320px" }}
              />
            </div>
          </div>
          <div className="flex-row-ns flex justify-around">
            <div className="alteration-input w-50 pa1 mr1">
              <label>Description</label>
              <input
                id="Description"
                className=" pa2 input-reset ba bg-transparent  hover-black w-100"
                type="text"
                placeholder="Description"
                name="Description"
                onChange={handleChange}
                // style={{ width: "320px" }}
              />
            </div>

            <div className="w-50 pa1 mr1">
              <label>Custom Service</label>
              <input
                id="Custom_Service"
                className="alteration_custom_service_input pa2 input-reset ba bg-transparent  hover-black w-100 "
                type="number"
                placeholder="$ 0.00"
                name="Custome_Service"
                onChange={handleChange}
              />
            </div>
          </div>
      
            <div className="flex-row-ns flex justify-around">
              <div className="alteration-input w-50 pa1 mr2">
                <label>Tax</label>
                <input
                  id="Tax"
                  className="cmn-toggle cmn-toggle-round-flat"
                  type="checkbox"
                  onClick={handleChange} 
                  value={toggleValue}
                />
                <label htmlFor="Tax"></label>
              </div>

              <div className="alteration-input w-50 pa1 mr3 mt4">
                <button
                  disabled={
                    state.Customer_Phone === "" ||
                    state.Due_Date === "" ||
                    state.Customer_Name === ""
                      ? true
                      : (state.Custome_Service === 0 ||
                          state.Custome_Service === "") &&
                        printObj.orders.length === 0
                      ? true
                      : false
                  }
                  onClick={submitHandler}
                  className="ph3 pv2 input-reset ba bg-transparent grow pointer f dib"
                >
                  CREATE
                </button>
              </div>
              <div className="alteration-input w-50 pa1 mr3 mt4"></div>
              <div className="alteration-input w-50 pa1 mr3 mt4"></div>
            </div>

        </div>
        <div className={width > 800 ?" w-50 pa3 mr2":""}>
          <Scroll>
            <div className={width > 800 ?"pa4":""}>
              <fieldset className="main-fieldset ">                
                {sortServices.map(service => {
                    return <AlterationItem 
                        service={service} 
                        handleChange={handleChange}
                        key={service.name} 
                    />
                })}             
              </fieldset>
            </div>
          </Scroll>              
        </div>
      </div>
    </React.Fragment>
  );
}

export default NewAlterations;
